import React from "react";
import { Box, Icon, type IconProps } from "@chakra-ui/react";

export function EventIcon(props: IconProps) {
  return (
    <Icon width="17px" height="17px" fill="none" viewBox="0 0 17 17" {...props}>
      <rect width="15.992" height="15.992" x=".721" y=".322" fill="#3498DA" rx="4.798" />
      <rect width="15.992" height="15.992" x=".721" y=".322" fill="url(#event-icon-a)" rx="4.798" />
      <Box
        as="path"
        fill="#fff"
        d="M8.718 4.72a3.609 3.609 0 0 0-3.599 3.598 3.609 3.609 0 0 0 3.599 3.599 3.609 3.609 0 0 0 3.598-3.599A3.609 3.609 0 0 0 8.718 4.72Zm0 6.477a2.882 2.882 0 0 1-2.879-2.879A2.882 2.882 0 0 1 8.718 5.44a2.882 2.882 0 0 1 2.878 2.878 2.882 2.882 0 0 1-2.878 2.879Zm.18-4.678h-.54v2.16l1.87 1.15.289-.467-1.62-.972V6.52Z"
      />
      <Box as="defs">
        <linearGradient id="event-icon-a" x1="8.718" x2="8.718" y1=".322" y2="16.315" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0" />
          <stop offset="1" stopOpacity=".1" />
        </linearGradient>
      </Box>
    </Icon>
  );
}
